<script setup>
import { blocks } from "@/constants/dynamicBlocks.json";

const props = defineProps({
    data: Object,
    floatingBlock: Object
});

const sections = props.data && props.data.blocks ? props.data.blocks : []
const carousel = props.data && props.data.carousel ? props.data.carousel : null;
const pulseCourse = props.data && props.data.pulseCourse ? props.data.pulseCourse : {};
const price = ref(pulseCourse.price);
const aboutCourseTitle = props.data && props.data.aboutCourseTitle ? props.data.aboutCourseTitle : 'About This Course';
const topicsCoveredTitle = props.data && props.data.topicsCoveredTitle ? props.data.topicsCoveredTitle : 'Topics Covered';
const halfWidthComponents = sections.filter(component => component.options.columnSize === 'half-width');
const fullWidthComponents = sections.filter(component => component.options.columnSize === 'full-width');

const formattedPrice = computed(() => {
  const priceValue = price.value;
  if (priceValue >= 1000) {
    return priceValue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  } else {
    return `$${priceValue}`;
  }
});
const floatingBlockType = props.data.floatingBlock !== null ? props.data.floatingBlock.blockType : props.data.floatingBlockType;
const showFloatingBlockFooter = floatingBlockType !== 'floating-block-lead-gen'
// // Add or remove class from body dynamically
onMounted(() => {
  if (showFloatingBlockFooter) {
    document.body.classList.add('has-floating-footer')
  }
})

onUnmounted(() => {
  if (showFloatingBlockFooter) {
    document.body.classList.remove('has-floating-footer')
  }
})
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-lg-6 py-2">
        <Carousel :data="carousel" :isStatic="true"/>
      </div>
      <div class="col-sm-12 col-lg-6 py-lg-2">
        <CourseDetails :variants="props.data.variants" :data="pulseCourse" :price="props.data && props.data.price ? props.data.price : formattedPrice" :title="props.data.title"/>
      </div>
    </div>
    <hr class="w-100">
    <div class="row content-grid">
      <div class="col-sm-12 col-lg-6">
        <div class="static-component">
          <UIHeading :titleComponent="{title: aboutCourseTitle, heading: 'h2'}" :titleClass="'title px-2'" />
          <GenericContent :data="{content: pulseCourse.description}"/>
        </div>
        <hr class="w-100">
        <div class="static-component">
          <UIHeading :titleComponent="{title: topicsCoveredTitle, heading: 'h2'}" :titleClass="'title px-2'"/>
          <GenericContent :data="{content: pulseCourse.activityDesc}"/>
        </div>
        <hr class="w-100">
        <div class="half-width-wrapper">
          <LayoutDynamicComponents v-if="halfWidthComponents" :sections="halfWidthComponents" />
        </div>
      </div>
      <div class="col-6">
        <component :is="floatingBlockType" :options="floatingBlock" :course="data" v-if="data.displayFloatingBlock"></component>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 full-width-wrapper">
        <LayoutDynamicComponents v-if="fullWidthComponents" :sections="fullWidthComponents" />
      </div>
    </div>
    <FloatingBlockFooterDesktop :data="floatingBlock" backToBlockSelector=".content-grid" v-if="floatingBlockType !== 'floating-block-lead-gen'"></FloatingBlockFooterDesktop>
  </div>
</template>